import React, { useEffect, useState } from "react";
import Navbar from "../layout/Navbar";
import LogoCapsuleSection from "./LogoCapsules";
import ResearchSection from "./ResearchSection";
import PricingPlan from "./PricingPlan";
import Pricing from "../pages/Pricing";
import CustomerReviews from "./CustomerReviews";
import Footer from "../layout/Footer";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client"; // Import axiosClient
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons"; // Import the icon

const keywords = ["Industry Reports", "Market Insights", "Consumer Data"];

const HeroSection = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.trim()) {
        handleSearch(searchQuery);
      } else {
        // Clear the search results if the query is empty
        setSearchResults([]);
      }
    }, 300); // Adjust the debounce delay as needed

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  const handleSearch = async (query) => {
    if (query.trim()) {
      try {
        const response = await axiosClient.get(
          `/reports/search-by-title/?title=${query}`
        );
        const searchResults = response.data;
        setSearchResults(searchResults);
        console.log("Search results:", searchResults);
        // Handle the search results as needed
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    }
  };

  const handleResultClick = (report) => {
    navigate(`/report`, { state: report });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tokenExpiration = token;
      const isTokenExpired =
        tokenExpiration && new Date(tokenExpiration) < new Date();

      if (isTokenExpired) {
        localStorage.clear();
        alert("Your session has expired. Please log in again.");
        navigate("/");
        console.log();
      }
    }
  }, [navigate]);

  return (
    <>
      <section className="py-16 text-center">
        <div className="xl:text-5xl lg:text-4xl lg:block hidden text-lg font-semibold font4 font-urban mb-4">
          <h1 className=" max-w-4xl mx-auto pb-2">
            Empower Your Business Decisions with
          </h1>
          <h1 className="max-w-3xl mx-auto pb-2">
            Our Comprehensive and Dynamic
          </h1>
          <h1 className=" max-w-4xl mx-auto pb-4">
            Market Research Insights Platform!
          </h1>
        </div>

        <p className="text-lg mb-8 max-w-4xl mx-auto font-urban">
          Access in-depth market insights with ease. Search, filter, and
          download reports across industries, regions, and segments all through
          an intuitive platform designed for informed decision-making.
        </p>

        <div className="relative max-w-4xl mx-auto mb-4 px-4">
          <input
            type="text"
            placeholder="Search for any services"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-md font-euclid shadow-sm pr-12"
          />
          <button
            onClick={() => handleSearch(searchQuery)}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-pink text-white px-4 h-[calc(100%-2px)] rounded-r-md flex items-center justify-center"
          >
            <img src="images/search.png" alt="search" className="w-5 h-5" />
          </button>
        </div>

        {/* Display search results */}
        {searchResults.length > 0 && (
          <div className="max-w-4xl mx-auto mt-4 px-4">
            <ul className="bg-white border border-gray-300 rounded-md shadow-sm">
              {searchResults.map((result, index) => (
                <li
                  key={index}
                  className="px-4 py-2 text-left border-b border-gray-200"
                >
                  <button
                    className="flex justify-between items-center w-full text-left text-blue-500 hover:text-blue-700"
                    onClick={() => handleResultClick(result)}
                  >
                    <span>{result.reportTitle}</span>
                    <FontAwesomeIcon icon={faUpRightFromSquare} />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Capsule Section */}
        {/* <div className="max-w-4xl mx-auto font-urban flex flex-wrap items-center gap-2 md:gap-3 px-4">
          <span className="text-gray-600">Keywords:</span>
          {keywords.map((keyword, index) => (
            <div
              key={index}
              className="text-sm px-3 md:px-4 py-1 border border-gray-300 rounded-full text-gray-700 bg-white hover:bg-gray-100 cursor-pointer"
            >
              {keyword}
            </div>
          ))}
        </div> */}
        <div className="py-10 max-w-2xl mx-auto font-urban ">
          <h1 className="text-4xl font-semibold pb-4">What we Provide</h1>
          <p className="text-lg">
            Comprehensive insights, powerful search tools, and efficient content
            management all in one platform.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="w-full bg-gray-50 p-6 rounded-lg hover:shadow-xl hover:bg-white hover:shadow-blue-300 hover:border hover:border-blue-300 ">
            <div className="flex items-center gap-3 pb-2">
              <img src="images/v0.png" alt="search" className="w-5 h-5" />
              <h3 className="text-lg font-bold font5 font-inter">
                Comprehensive Industry Reports
              </h3>
            </div>

            <p className=" text-left font-dmSans font6">
              Access detailed reports tailored to your industry for informed
              decision-making, with real-time data, trend analysis
            </p>
          </div>
          <div className="w-full bg-gray-50 p-6 rounded-lg hover:bg-white hover:shadow-xl hover:shadow-blue-300 hover:border hover:border-blue-300">
            <div className="flex items-center gap-3 pb-2">
              <img src="images/v3.png" alt="search" className="w-5 h-5" />
              <h3 className="text-lg font-bold font5 font-inter">
                Dynamic Filtering and Search
              </h3>
            </div>
            <p className="text-left font-dmSans font6">
              Easily find and filter insights with our intuitive search
              capabilities, you can quickly access the most relevant data for
              your needs
            </p>
          </div>
          <div className="w-full bg-gray-50 p-6 rounded-lg hover:bg-white hover:shadow-xl hover:shadow-blue-300 hover:border hover:border-blue-300">
            <div className="flex items-center gap-3 pb-2">
              <img src="images/v2.png" alt="search" className="w-5 h-5" />
              <h3 className=" font-bold font5 font-inter">
                Streamlined Content Management
              </h3>
            </div>
            <p className="  text-left font-dmSans font6">
              Efficiently manage and update content with our robust admin panel,
              designed to streamline operations
            </p>
          </div>
        </div>

        <div className="flex py-10 items-center justify-center gap-2">
          <p className="font-medium">Trusted By 20,000+ Clients</p>
          <div className="flex">
            <img src="images/star.png" alt="logo" className="w-3 h-3" />
            <img src="images/star.png" alt="logo" className="w-3 h-3" />
            <img src="images/star.png" alt="logo" className="w-3 h-3" />
            <img src="images/star.png" alt="logo" className="w-3 h-3" />
            <img src="images/star-gray.png" alt="logo" className="w-3 h-3" />
          </div>
        </div>
        <div className="pb-10 max-w-2xl mx-auto font-urban ">
          <h1 className="text-4xl font-semibold pb-4">They Trust Us</h1>
        </div>
        <LogoCapsuleSection />
        <ResearchSection />
        <Pricing />
        <CustomerReviews />
      </section>
    </>
  );
};

export default HeroSection;
